import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const TABS = ["instructions", "equipments"] as const;
type TabType = (typeof TABS)[number];

const ProgramVideoNavigation = () => {
  const { t } = useTranslation("goService", { keyPrefix: "programVideoDetailsPage" });

  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab") || "instructions";

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", newValue);

    navigate({ search: searchParams.toString() });
  };

  return (
    <Tabs
      value={currentTab}
      onChange={handleTabChange}
      aria-label="program video details tabs"
      sx={{
        minHeight: "fit-content",
        borderBottom: "1px solid var(--Gray-200, #E4E7EC)",
        "& .MuiTabs-flexContainer": {
          gap: "24px",
        },
      }}
    >
      {TABS.map((tab) => {
        return <Tab key={tab} label={t(tab)} value={tab} sx={styles.tabStyle(tab === currentTab)} />;
      })}
    </Tabs>
  );
};

export default ProgramVideoNavigation;

const styles = {
  tabs: {
    minHeight: "fit-content",
    borderBottom: "1px solid var(--Gray-200, #E4E7EC)",
    "& .MuiTabs-flexContainer": {
      gap: "24px",
    },
  },
  tabStyle: (isActive: boolean) => ({
    color: isActive ? "var(--Brand-700, #076D0D)" : "var(--Gray-500, #667085)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    padding: "0px 4px 12px 4px",
    textTransform: "none",
    minHeight: "36px",
    minWidth: "fit-content",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  }),
};
